import React, { Fragment, useEffect, useLayoutEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './WriteNews.scss';
import { setTopNavbar, clearTopNavbar } from '../../Reducers/actions/navbarActions';
// import { useEffect } from 'react';
import Icon from '../../components/Icon/Icon';
import NewsEditor from '../../components/NewsEditor/NewsEditor';
import { fetchAddNews } from '../../Reducers/actions/newsActions';
import PreviewNews from '../../components/PreviewNews/PreviewNews';
import { getFirstTitleFromHtml } from '../../../helpers/utilities';
import { useNavigate } from 'react-router-dom';
import { setUserRole } from '../../Reducers/actions/authActions';
import { cachingService } from '../../../helpers/cache';
import { updateUploadProgress, uploadSuccess } from '../../Reducers/actions/uploadActions';
import useSocialNetworksPrompt from '../../hooks/useSocialNetworksPrompt';
import SocialNetworksPrompt from '../../components/SocialNetworksPrompt/SocialNetworksPrompt';
import { userNeedsEmailVerificationOrPasswordSetup } from '../../constants/signupFlow';

const WriteNews = () => {

  const { user, session } = useSelector(state => ({
    user: state.auth?.user,
    session: state.auth?.session,
  }))

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [step, setStep] = useState(1)
  const [content, setContent] = useState('')
  const [media_url, setMediaUrl] = useState()
  const [isNotValid, setIsNotValid] = useState(false)
  const [error, setError] = useState('')
  const [isPublishing, setIsPublishing] = useState(false)

  // Social networks prompt modal (news publish trigger - creators only, immediate)
  const socialNetworksPrompt = useSocialNetworksPrompt('news-publish');

  const blockedFromPublishing =
    userNeedsEmailVerificationOrPasswordSetup(user, session);

  useLayoutEffect(() => {
    if (blockedFromPublishing) {
      navigate('/explore', { replace: true });
    }
  }, [blockedFromPublishing, navigate]);

  // Set the desktop nav title (otherwise it shows the previous screen's title).
  useEffect(() => {
    dispatch(setTopNavbar({ title: 'Write a News', showBackArrow: true }));
    return () => { dispatch(clearTopNavbar()); };
  }, [dispatch]);

  const handleNext = () => {
    setStep(step + 1)
  }

  const handlePublish = () => {
    if (media_url) {
      setIsPublishing(true)
      const formData = new FormData()
      formData.append('media', media_url)
      formData.append('title', getFirstTitleFromHtml(content))
      formData.append('content', content)
      dispatch(updateUploadProgress(90));
      fetchAddNews(formData).then((res) => {
        if (res.success) {
          cachingService.invalidate([`/api/news/${user?.user_id}`], true);
          dispatch(updateUploadProgress(100));
          dispatch(uploadSuccess())
          if (user?.role === 'customer') {
            dispatch(setUserRole('creator'))
          }
          // Show social networks prompt if creator has no social links
          if (socialNetworksPrompt.shouldShow) {
            socialNetworksPrompt.openModal();
          }
          navigate('/news')
        } else {
          setIsPublishing(false)
        }
      })
    } else {
      setIsNotValid(true)
      setError('Please add a thumbnail for your news to publish.')
    }
  }


  const handleUploadMedia = (file) => {
    setIsNotValid(false)
    setError(null)
    // const formData = new FormData()
    // formData.append('media_url', file)
    setMediaUrl(file)
  }

  if (blockedFromPublishing) {
    return null;
  }

  return (
    <Fragment>
      {socialNetworksPrompt.isOpen && (
        <SocialNetworksPrompt 
          open={socialNetworksPrompt.isOpen} 
          onClose={socialNetworksPrompt.closeModal} 
        />
      )}
      <div className='write-container'>
        <div
          className='write-header d-flex aic jcc mx-16'
          style={{
            '--progress': `${(step / 2) * 100}%`
          }}
        >
          <span className='back-icon' onClick={() => step === 2 ? setStep(step - 1) : navigate('/news')}>
            <Icon alias='chevron-left' width={24} color='#0A0F1E' />
          </span>
          <p className='fs-sm2 fg-dark fw-bold'>WRITE A NEWS</p>
          {step === 1 && <button
            onClick={handleNext}
            className="btn btn-sm red-btn rounded-xl fs-xxs p-fixed px-16"
            style={{ right: '16px' }}
            disabled={content?.length === 0}
          >
            NEXT
          </button>}
          {/* {step === 1 && <button
            className='btn btn-sm btn-outline-white rounded-md fg-crea ml-auto next-btn px-24'
            onClick={handleNext}
            disabled={content?.length === 0}
          >Next
          </button>} */}
        </div>
        <div className="progress-bar" />
      </div>
      {step === 1 ?
        <div className='writer pt-40 mt-40'>
          <NewsEditor value={content} onChange={setContent} />
        </div>

        :
        <div className='preview-news mt-40'>
          <PreviewNews
            classNames='mt-32'
            content={content}
            onUploadMedia={handleUploadMedia}
            isNotValid={isNotValid}
          />
          {error && <p className='fs-real fw-medium fg-xtred ta-center'>{error}</p>}
          <button
            className='publish btn red-btn btn-full aic jcc fw-bold mb-16'
            onClick={handlePublish}
            disabled={content?.length === 0 || isPublishing}
          >
            {isPublishing ? "Publishing..." : "Publish"}</button>
        </div>}
    </Fragment>
  );
};

export default WriteNews; 